import {
  Box,
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import React from "react";
import QRIS from "../../assets/payment/qris.png";
import BPD from "../../assets/logo/bank-bpd.png";

export default function PaymentMethod({
  open,
  onClose,
  email,
  setEmail,
  payment,
  setPayment,
  countBarang,
  hargaTotal,
  tax,
  listTrue,
  handlePay,
  loading,
}) {
  var IDRConvert = Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  });
  return (
    <Modal isOpen={open} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Modal Title</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box borderRadius="10px" border="2px solid #B9B9B9" p="10">
            <Text fontWeight="600" fontSize="20" py="3">
              Detail Pembayaran
            </Text>
            <FormControl>
              <FormLabel fontWeight="500">Email</FormLabel>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormControl>
            <Text fontWeight="600" fontSize="16" py="3">
              Metode pembayaran
            </Text>
            <RadioGroup
              defaultValue={payment}
              onChange={(value) => setPayment(value)}
            >
              <HStack>
                <Radio
                  size="lg"
                  name="1"
                  colorScheme="blue"
                  px="2"
                  value="QRIS"
                >
                  <img src={QRIS} alt="qris" width="100px" />
                </Radio>
                <Box display="flex" alignItems="center">
                  <Radio
                    px="2"
                    size="lg"
                    name="1"
                    colorScheme="blue"
                    value="VA"
                  />
                  <img src={BPD} alt="BPD" width="70px" />
                  <Text pl="4" fontSize="20px">
                    Virtual Account
                  </Text>
                </Box>
              </HStack>
            </RadioGroup>
            <Text fontWeight="600" fontSize="16" py="3">
              Ringkasan belanja
            </Text>
            <SimpleGrid columns={2} alignContent="center">
              <Text fontSize="16" color="#4E4E4E">
                Harga ({countBarang} Barang)
              </Text>
              <Text
                display="flex"
                justifyContent="flex-end"
                fontWeight="700"
                fontSize="20"
              >
                {IDRConvert.format(hargaTotal)}
              </Text>
              <Text fontSize="16" color="#4E4E4E">
                Pajak
              </Text>
              <Text
                display="flex"
                justifyContent="flex-end"
                fontWeight="700"
                fontSize="20"
              >
                {IDRConvert.format(tax)}
              </Text>
              <Text fontSize="16" color="#4E4E4E">
                Total Harga
              </Text>
              <Text
                display="flex"
                justifyContent="flex-end"
                fontWeight="700"
                fontSize="20"
              >
                {IDRConvert.format(hargaTotal)}
              </Text>
            </SimpleGrid>
            <Button
              mt="5"
              py="5"
              variant="outline"
              colorScheme="blue"
              w="full"
              disabled={listTrue.length === 0}
              onClick={handlePay}
              isLoading={loading}
            >
              Bayar
            </Button>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
